export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white text-center p-4 mt-8">
      © {new Date().getFullYear()} Innercircle Softech Private Limited
    </footer>
  );
}
